<template>
  <div>
    <sticky-ask-us-btn v-if="$vuetify.breakpoint.mdAndUp" />

    <v-container fluid grid-list-xl px-0 py-2>
      <v-layout row wrap>
        <v-flex sm12 md7>
          <cart-item v-for="item in $cart.items" :key="item.id" :artwork="item" />
          <tk-btn to="/search" color="primary" large>{{ $t('COMMON.CONITNUE_SHOPPING') }}</tk-btn>
        </v-flex>
        <v-flex sm12 md5 v-if="$cart.items.length">
          <totals />

          <!-- Show payment options cards -->
          <tk-payment-options class="mt-4" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { useGTag } from '../../services/google/google-tag-manager'

export default {
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!

    next(vm => {
      console.log("BeforeRouerEnter", vm.$cart.items);
      if (!vm.$cart.items.length) {
        console.log("Redirect");
        next({ name: "home" });
      }
    });
  },

  components: {
    Totals: () => import("./Totals"),
    CartItem: () => import("./CartItem"),
    TkPaymentOptions: () => import("@/components/core/TkPaymentOptions"),
    StickyAskUsBtn: () => import("@/components/core/StickyAskUsBtn")
  },
};
</script>
